import { Icon, IconButton, Paper } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import { EventStatusEnum } from "../../_common/enum/forms/eventStatus.enum";
import { IFilteringViewModel } from "../../_common/interface/table";
import { PageHeader } from "../../_components/header/page.header";
import { CommonTable } from "../../_components/table/common.table";
import { getDate } from "../../_helpers/dateTime.helper";
import { getMoneyFormat } from "../../_helpers/format.helper";
import { accountService } from "../../_services/accounts.service";
import { eventService } from "../../_services/event.service";
import { EventManageDrawer } from "../event/event-manageDrawer";
import { EventDocumentUpload } from "../eventDocument/eventDocument-upload";


export function UserProfileMyEventList(params: {}) {
    const navigate = useNavigate();
    const { userId } = useParams<{ userId: string }>();

    const [data, setData] = useState({ items: [], count: 0 });
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState<IFilteringViewModel>({ search: '', limit: 100, page: 0, order: 'desc', orderBy: '' });

    useEffect(() => {
        fetchData();
    }, [filter]);

    function fetchData() {
        if (!userId) return;

        setLoading(true);
        return eventService.getAll({ ...filter, userId: userId })
            .then(
                (json) => {
                    setData(json)
                }
            )
            .finally(() => setLoading(false));
    }

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'name',
                header: 'Name',
            },
            {
                accessorKey: 'eventStatusId',
                header: 'Status',
                accessorFn: (rowData: any) => <>{EventStatusEnum[rowData.eventStatusId].toString()}</>
            },
            {
                accessorKey: 'price',
                header: 'Price',
                accessorFn: (rowData: any) => <>{getMoneyFormat(rowData.price)}</>
            },
            {
                accessorKey: 'eventDate',
                header: 'Event Date',
                accessorFn: (rowData: any) => <>{getDate(rowData.eventDate)}</>
            },
        ],
        [],
    );

    return (
        <>

            <PageHeader
                pageName="Events"
                actionType="create"
            />

            <Paper>

                <CommonTable
                    columns={columns}
                    data={data}
                    filter={filter}
                    setFilter={(_filter) => { setFilter({ ...filter, ..._filter }) }}
                    isLoading={isLoading}
                // renderRowActions={(row: any, table: any) => <>
                //     {accountService.isOrganiser &&
                //         <IconButton
                //             color="primary"
                //             onClick={() => {
                //                 navigate("Manage/" + (row.original as any).id)
                //             }}>
                //             <Icon>edit</Icon>
                //         </IconButton>
                //     }

                //     <IconButton
                //         color="primary"
                //         onClick={() => {
                //             navigate("../Events/View/" + (row.original as any).id)
                //         }}>
                //         <Icon>visibility</Icon>
                //     </IconButton>

                // </>}
                />

                <Routes>
                    <Route path="Manage/:eventId" element={<EventManageDrawer emitOnSave={() => { navigate(""); fetchData(); }} emitOnClose={() => { navigate("") }} />} >
                        <Route path="EventDocuments" element={<EventDocumentUpload emitOnSave={() => { }} />} />
                    </Route>
                </Routes>

            </Paper>
        </>
    );
}